import { render, staticRenderFns } from "./UpdatePackageInfo.vue?vue&type=template&id=f7bcddae&"
import script from "./UpdatePackageInfo.vue?vue&type=script&lang=js&"
export * from "./UpdatePackageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports